module.exports = __webpack_public_path__ + "img/bg_auth_tip.2dfd357c.png";